import ApolloClient from "apollo-client";

import { ApolloLink } from "apollo-link";
import { onError } from "apollo-link-error";
import { setContext } from "apollo-link-context";
import { InMemoryCache } from "apollo-cache-inmemory";
import { createUploadLink } from "apollo-upload-client";
import trackPendingQueriesLink from "./track-pending-queries-link";

const withToken = (opts) =>
  setContext(async (request) => {
    const accessToken = await opts.getTokenSilently();
    return {
      headers: {
        authorization: `Bearer ${accessToken}`,
      },
    };
  });

function Client(opts) {
  return new ApolloClient({
    link: ApolloLink.from([
      trackPendingQueriesLink,
      withToken(opts),
      onError(({ graphQLErrors, networkError }) => {
        if (networkError && networkError.statusCode === 401) {
          opts.redirectToLogin();
        }
      }),

      createUploadLink({ uri: `${opts.uri}/graphql` }),
    ]),

    cache: new InMemoryCache({ addTypename: false }),
  });
}

export default Client;
